import { create } from 'zustand';

import { createAppointmentStoreSlice } from './appointment/slice';
import { createBasketStoreSlice } from './basket/slice';
import { createJourneyStoreSlice } from './journey/slice';
import { type Store } from './types';

const useBoundStore = create<Store>()((...args) => ({
  ...createAppointmentStoreSlice(...args),
  ...createBasketStoreSlice(...args),
  ...createJourneyStoreSlice(...args),
}));

export { useBoundStore };
